export class EventBus {
    constructor() {
        this.listeners = new Map();
    }

    on(type, listener) {
        const listeners = this.listeners.get(type) || new Set();

        listeners.add(listener);
        this.listeners.set(type, listeners);

        return () => this.off(type, listener);
    }

    off(type, listener) {
        const listeners = this.listeners.get(type);

        listeners?.delete(listener);

        if (listeners?.size === 0) {
            this.listeners.delete(type);
        }
    }

    emit(type, detail) {
        const listeners = this.listeners.get(type);

        if (!listeners) {
            return;
        }

        [...listeners].forEach((listener) => {
            try {
                listener(detail);
            } catch (error) {
                console.error(`Falha no listener "${type}".`, error);
            }
        });
    }

    clear() {
        this.listeners.clear();
    }
}
